import FormField from "./FormField";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useAuthHttp from "../hooks/useAuthHttp";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import Container from "./Container";
import Text from "./Text";
import Icon from "./Icon";

export interface IFinancialResponse {
    financial_list: IFinancialList[]
}
  
export interface IFinancialList {
    financial_inst_name: string
    financial_inst_address: IFinancialInstAddress
    _id: string
}
  
export interface IFinancialInstAddress {
    uf: string
    city: string
}

interface ISelectedBank {
    id: string;
    name: string;
}
 
interface IBankSearchSelectorProps {
    label: string;
    hasError?: boolean;
    error?: string;
    selected?: ISelectedBank;
    onSelectBank: (bank: IFinancialList|null) => void;
}

const BankSearchSelector = ({ hasError, error, label, selected, onSelectBank }: IBankSearchSelectorProps) => {
    const [searchQuery, setSearchQuery] = useState("");
    const authHttp = useAuthHttp();
    const bankSearchQuery = useQuery({
        queryKey: ["banks", searchQuery],
        queryFn: async () => {
            if (searchQuery.length < 3) {
                return null;
            }

            return await authHttp.doGet<IFinancialResponse>(`financials/find?name=${searchQuery}`);
        }
    });

    const [searchQueryTimeouted, setSearchQueryTimeouted] = useState<string>("");

    useEffect(() => {
        const timeout = setTimeout(() => {
            setSearchQuery(searchQueryTimeouted);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQueryTimeouted]);

    return (
        <FormField
            id="bank"
            label={label}
            hasError={hasError}
            error={error}
        >
            <Container relative>
                <InputText 
                    value={selected?.name ?? searchQueryTimeouted}
                    className="w-full pr-5"
                    invalid={hasError}
                    onChange={(e) => {
                        setSearchQueryTimeouted(e.target.value);
                    }}
                />
                
                {
                    selected && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            onSelectBank(null);
                            setSearchQueryTimeouted("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                bankSearchQuery.isFetching && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                bankSearchQuery.data?.financial_list?.length && !selected && searchQueryTimeouted && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            bankSearchQuery.data?.financial_list.map(f => {
                                return (
                                    <li key={f._id}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                onSelectBank(f);
                                            }}
                                        >
                                            {f.financial_inst_name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default BankSearchSelector;
